export const Constants = {
    "USERNAME" : "USERNAME",
    "USERTYPE" : "USERTYPE",
    "USERID" : "USERID",
    "APP_KEY" : "APP_KEY",
    "OPENEDMENU" : "OPENEDMENU",
}